export default __webpack_public_path__ + "static/media/toolkit-logo-x2.b530b7c2.png";